import { AudioUploadBtn } from './upload-btn'

import * as Styled from './styled'

export const AudioTabActions: React.FC = () => {
  return (
    <Styled.AudioTabActionsWrapper>
      <AudioUploadBtn />
    </Styled.AudioTabActionsWrapper>
  )
}
